"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const MobileIcon = () => /*#__PURE__*/_react.default.createElement("svg", {
  width: "87",
  height: "64",
  viewBox: "0 0 87 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M3.186 37.5V27.51L0.576 29.22V26.736L3.546 24.63H6.102V37.5H3.186ZM12.0482 37.5L15.2702 32.694L12.2642 28.086H15.2522L17.0162 30.912L18.7442 28.086H21.4442L18.4382 32.496L21.7502 37.5H18.7442L16.7642 34.332L14.7302 37.5H12.0482Z",
  fill: "#333333"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M45.7143 11C44.0268 11 42.7143 12.4062 42.7143 14V50C42.7143 51.6875 44.0268 53 45.7143 53H63.7143C65.308 53 66.7143 51.6875 66.7143 50V14C66.7143 12.4062 65.308 11 63.7143 11H45.7143ZM39.7143 14C39.7143 10.7188 42.3393 8 45.7143 8H63.7143C66.9955 8 69.7143 10.7188 69.7143 14V50C69.7143 53.375 66.9955 56 63.7143 56H45.7143C42.3393 56 39.7143 53.375 39.7143 50V14ZM51.7143 45.5H57.7143C58.4643 45.5 59.2143 46.25 59.2143 47C59.2143 47.8438 58.4643 48.5 57.7143 48.5H51.7143C50.8705 48.5 50.2143 47.8438 50.2143 47C50.2143 46.25 50.8705 45.5 51.7143 45.5Z",
  fill: "#66788C"
}));
var _default = exports.default = MobileIcon;